<button
  class="btn btn-sm ca-btn ca-btn-neutral-command"
  (click)="onButtonClick($event)"
  ngbTooltip="{{ '::RemoveNode' | abpLocalization }}"
  container="body"
  placement="bottom"
>
  <ca-delete-icon></ca-delete-icon>
</button>
